import { lazy, Suspense } from 'react';
import { useLiveCallStatesStore } from '../stores/live-call-states.store';

const LiveCallDrawer = lazy(() => import('./live-call.drawer').then((module) => ({ default: module.LiveCallDrawer })));
const LiveTranscriptionPanel = lazy(() =>
  import('./live-transcription-panel').then((module) => ({ default: module.LiveTranscriptionPanel }))
);

export function LiveCallOverlays() {
  const transcriptSession = useLiveCallStatesStore((state) => state.transcriptSession);
  const isDrawerOpen = useLiveCallStatesStore((state) => state.isDrawerOpen);

  return (
    <>
      {transcriptSession && (
        <Suspense>
          <LiveTranscriptionPanel />
        </Suspense>
      )}

      {isDrawerOpen && (
        <Suspense>
          <LiveCallDrawer />
        </Suspense>
      )}
    </>
  );
}
